import { BaseConnection } from "./connection";

export enum SystemVersionReferenceToEntity {
  PERSON = "person",
  VERSION = "version",
}

export enum VersionReferenceTypes {
  REFERENCE_ONLY = "reference only",
  REFERENCE_WITH_QUOTATION = "reference with quotation",
  REFERENCE_WITH_PARAPHRASE = "reference with paraphrase",
  QUOTATION_WITHOUT_REFERENCE = "quotation without reference",
  PARAPHRASE_WITHOUT_REFERENCE = "paraphrase without reference",
  BORROWING = "borrowing",
}

export enum SystemVersionConnectionDirection {
  REFERRING_TO = "referring_to",
  REFERENCED_BY = "referenced_by",
}

export type ReferenceVersionConnection = BaseConnection & {
  system_reference_to_entity: SystemVersionReferenceToEntity | null;
  version_reference_type: VersionReferenceTypes | null;
  system_referring_to_version_connection_type:
    | SystemVersionConnectionDirection
    | null;
};
